module.exports = __webpack_public_path__ + "img/IT0000552841118.2a554b9a.png";